import React from 'react';
import { isActiveTeamUser } from '../../lib/traceability';

// #Fase3-G3 — Incluso un miembro fuera de la página o suspendido debe poder retirarse.
export default function TeamSelector({ users, value = [], onChange, principalId }) {
  // #Fase3-G3 — La API excluye al principal actual; solo el anterior puede retenerse en la misma reasignación.
  const available = users.filter((user) => isActiveTeamUser(user) && user.id !== principalId);
  const missing = value.filter((id) => id !== principalId && !available.some((user) => user.id === id));
  const choices = [...available, ...missing.map((id) => ({
    id, name: `${users.find((user) => user.id === id)?.name || 'Integrante del equipo'} (no disponible)`,
  }))];
  return <fieldset className="soem-card p-4 space-y-2">
    <legend>Equipo adicional del evento</legend>
    <p className="text-xs">
      El principal va aparte. Para conservar al principal anterior, en Editar evento cambia el principal,
      marca al anterior en el equipo adicional y guarda ambos cambios juntos.
    </p>
    {choices.map((user) => <label key={user.id} className="block text-sm">
      <input type="checkbox" checked={value.includes(user.id)} onChange={(e) => {
        onChange(e.target.checked ? [...value, user.id] : value.filter((id) => id !== user.id));
      }} /> {user.name || 'Integrante del equipo'}
    </label>)}
  </fieldset>;
}
